module.exports = __webpack_public_path__ + "static/media/qr-code-red.ce27cab5.png";